import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import MeetingsPage from './pages/MeetingsPage';
import ProjectsPage from './pages/ProjectsPage';
import TemplatesPage from './pages/TemplatesPage';
import JiraIntegrationPage from './pages/JiraIntegrationPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Dedicated Separate Landing / Showcase Homepage */}
        <Route path="/" element={<LandingPage />} />

        {/* Privacy Policy Page */}
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

        {/* Authenticated Workspace & Sub-pages */}
        <Route element={<MainLayout />}>
          <Route path="/workspace" element={<HomePage />} />
          <Route path="/meetings" element={<MeetingsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/jira" element={<JiraIntegrationPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
